



















import Component, { mixins } from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import ScrollView from '@/components/ScrollView.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { AgingFilterFormsMixin } from '@/views/app/management/collections/components/GlobalAging/AgingFilterFormsMixin'

@Component({
  components: { Checkbox, ScrollView, SearchInput }
})
export default class StatusFilterForm extends mixins(AgingFilterFormsMixin) {
  localOptions: any = [
    {
      value: 'ACTIVE',
      label: 'Current'
    },
    {
      value: 'INACTIVE',
      label: 'Discharged'
    }
  ]
}
